import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { CreateTripDownloadUrlInput, CreateTripDownloadUrlResponse, MutationCreateTripDocumentDownloadUrlArgs } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { CreateTripDocumentDownloadUrlDocument } from '@/api/queries';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateTripDownloadUrlInput]?: CreateTripDownloadUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateTripDownloadUrlResponse>;
}

// CreateTripDocumentDownloadUrl Service
export const { createTripDocumentDownloadUrl, recreateTripDocumentDownloadUrl, useCreateTripDocumentDownloadUrl } = ((): {
  createTripDocumentDownloadUrl: ServiceMethod;
  recreateTripDocumentDownloadUrl: ServiceMethod;
  useCreateTripDocumentDownloadUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(CreateTripDocumentDownloadUrlDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateTripDownloadUrlInput, options?: ConnectionOptions): Promise<CreateTripDownloadUrlResponse> => {
        const args: MutationCreateTripDocumentDownloadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createTripDocumentDownloadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createTripDocumentDownloadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createTripDocumentDownloadUrl: fetch,
    recreateTripDocumentDownloadUrl: refetch,
    useCreateTripDocumentDownloadUrl: useService,
  };
})();
